import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "sonner";

const SITE_URL = "https://heveatalent.com.br";

export const buildMatchText = (m) => {
  const remaining = m.remaining_jobs || 0;
  return [
    "✅ *VAGA PREENCHIDA!*",
    "",
    `📌 ${m.title}`,
    m.city ? `📍 ${m.city}` : null,
    m.hired_name ? `🤝 ${m.hired_name}${m.hired_city ? `, de ${m.hired_city},` : ""} foi contratado(a)!` : null,
    "",
    "Mais um profissional empregado através da HeveaTalent. 🤝",
    "Obrigado a todos que compartilharam!",
    "",
    remaining > 0
      ? `🌳 Ainda ${remaining === 1 ? "tem 1 vaga aberta" : `tem ${remaining} vagas abertas`}:`
      : "🌳 Fique de olho nas próximas vagas:",
    `${SITE_URL}/vagas`,
    "",
    "Tem vaga na sua fazenda? Divulgue grátis:",
    `${SITE_URL}/balcao`,
  ].filter((l) => l !== null).join("\n");
};

export const MatchDialog = ({ match, open, onOpenChange }) => {
  if (!match) return null;
  const text = buildMatchText(match);

  const copyText = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Post de comemoração copiado! É só colar nos grupos.");
    } catch {
      toast.error("Não consegui copiar — selecione o texto manualmente.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="match-dialog">
        <DialogHeader>
          <DialogTitle>🎉 Match feito! Divulgue a conquista</DialogTitle>
          <DialogDescription className="text-xs text-gray-500">
            A vaga saiu do ar. Poste nos grupos: cada "vaga preenchida" é prova de que a plataforma funciona — e atrai novas fazendas e profissionais.
          </DialogDescription>
        </DialogHeader>
        <div>
          <textarea
            readOnly
            value={text}
            className="w-full text-sm border rounded-lg p-3 bg-gray-50 h-56"
            data-testid="match-dialog-text"
          />
          <div className="flex flex-wrap gap-2 mt-2">
            <Button size="sm" onClick={copyText} data-testid="match-copy-btn">
              📋 Copiar texto
            </Button>
            <a
              href={`https://wa.me/?text=${encodeURIComponent(text)}`}
              target="_blank"
              rel="noreferrer"
              data-testid="match-whatsapp-btn"
            >
              <Button size="sm" className="bg-green-600 hover:bg-green-700">💬 Enviar no WhatsApp</Button>
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
